import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import MyAccountLayout from "@/components/MyAccountLayout"
import EditIcon from '@/svgs/edit-hover.svg'
import { useState, useEffect } from "react"
import Link from 'next/link'
import Image from 'next/image'
import dayjs from 'dayjs'
import { Button, Form, Input, DatePicker, Select, message } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import styles from "@/styles/my-account/contact-information.module.scss"
import myAccountApi from '@/service/modules/myAccountApi'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function MyaccountInformation() {
  const [form] = Form.useForm()
  const { Option } = Select

  interface dataInterface {
    login: string,
    phone: string,
    firstName: string,
    lastName: string,
    gender: number,
    dobMonth: string | null,
    dobYear: object | string,
    subscribed4news: number
  }

  // 获取用户信息
  const [customerData, setCustomerData] = useState<dataInterface | null>(null)
  const [customerGender, setCustomerGender] = useState(-1)
  const getCustomerInfo = async () => {
    try {
      let res = await myAccountApi.getCustomerInfo()
      if (res.data) {
        form.resetFields()

        const data = {
          login: res.data?.customer.login,
          phone: res.data?.customer.phone,
          firstName: res.data?.customer.firstName,
          lastName: res.data?.customer.lastName,
          gender: res.data?.customer.gender,
          dobMonth: res.data?.customer.dobMonth || null,
          dobYear: res.data?.customer.dobYear ? dayjs(`${res.data?.customer.dobYear}/01/01`) : '',
          subscribed4news: res.data?.customer.subscribed4news
        }

        form.setFieldsValue(data)

        setCustomerData(data)
        setCustomerGender(res.data?.customer.gender)
      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getCustomerInfo()
  }, [])

  // 月份信息选项
  const monthOptions = [
    { text: 'January', value: '1' },
    { text: 'February', value: '2' },
    { text: 'March', value: '3' },
    { text: 'April', value: '4' },
    { text: 'May', value: '5' },
    { text: 'June', value: '6' },
    { text: 'July', value: '7' },
    { text: 'August', value: '8' },
    { text: 'September', value: '9' },
    { text: 'October', value: '10' },
    { text: 'November', value: '11' },
    { text: 'December', value: '12' }
  ]
  // 获取当前年份的前一年
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;
  const datePickerIcon = <DownOutlined />

  // 切换性别
  const handleChangeGender = (value: number) => {
    const gender = customerGender !== value ? value : -1
    setCustomerGender(gender)
    form.setFieldsValue({ gender: gender })
  }

  // 校验成功，发起提交请求
  const onFinish = async (values: any) => {
    try {
      let dataObj = {
        login: values.login,
        phone: values.phone,
        firstName: values.firstName,
        lastName: values.lastName,
        gender: values.gender,
        dobMonth: values.dobMonth ? values.dobMonth : '',
        dobYear: values.dobYear ? values.dobYear.$y : ''
      }
      let res = await myAccountApi.updateCustomerInfo(dataObj)
      if (res.data) {
        message.success('Update Success')
      }
    } catch (error: any) {
      message.error(error.message)
    }
  }

  return (
    <>
      <Head>
        <title>
          My Account - BestDeals.co.nz
        </title>
      </Head>

      <DefaultLayout>
        <MyAccountLayout>
          <div className={styles['my-account-information']}>
            <div className={styles['title']}>Contact Information</div>

            <Form
              name="basic"
              layout="vertical"
              size={'large'}
              style={{ width: '100%' }}
              form={form}
              onFinish={onFinish}
              autoComplete="off"
              scrollToFirstError
            >

              <div className={styles['form-box']}>
                <div className={styles['box-item']}>

                  <Form.Item
                    label="Login Email"
                    name="login"
                    rules={[
                      { required: true, message: `'Login Email' is required` },
                      { type: 'email', message: `'Email' is required` },
                    ]}
                  >
                    <Input maxLength={225} suffix={<EditIcon style={{ width: '20px' }} />} />
                  </Form.Item>

                  <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[{ required: true, message: `'First Name' is required` },]}
                  >
                    <Input maxLength={60} suffix={<EditIcon style={{ width: '20px' }} />} style={{ width: '100%' }} />
                  </Form.Item>

                  <Form.Item
                    label="Gender"
                    name="gender"
                  >
                    <div className={styles['gender-box']}>
                      <Image
                        className={`${styles['main-img']} ${customerGender === 1 ? styles['active'] : ''}`}
                        src={`${imageDomain}/maleRadio.png`}
                        alt={'male'}
                        width={200}
                        height={40}
                        onClick={() => handleChangeGender(1)}
                      ></Image>

                      <Image
                        className={`${styles['main-img']} ${customerGender === 0 ? styles['active'] : ''}`}
                        src={`${imageDomain}/femaleRadio.png`}
                        alt={'female'}
                        width={200}
                        height={40}
                        onClick={() => handleChangeGender(0)}
                      ></Image>
                    </div>
                  </Form.Item>
                </div>

                <div className={styles['box-item']}>
                  <Form.Item
                    label="Phone"
                    name="phone"
                    rules={[
                      // { required: true, message: `'Phone' is required`},
                      {
                        validator(_, value) {
                          if (value && !value.match(/^[0][234578][0-9]{8}$/)) {
                            return Promise.reject(new Error('Invalid phone number.*'));
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}
                  >
                    <Input
                      type="tel"
                      maxLength={10}
                      placeholder="For delivery use only"
                      suffix={<EditIcon style={{ width: '20px' }} />}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Last Name"
                    name="lastName"
                    rules={[{ required: true, message: `'Last Name' is required` }]}
                  >
                    <Input
                      maxLength={60}
                      style={{ width: '100%' }}
                      suffix={<EditIcon style={{ width: '20px' }} />}
                    />
                  </Form.Item>

                  <div className={styles['box']}>
                    <div className={styles['box-title']}>DOB(<span className={styles['box-title-tips']}>You may receive a birthday gift from us!</span>)</div>
                    <div className={styles['post-code']}>
                      <div className={styles['post-code-item']}>
                        <Form.Item
                          name="dobMonth"
                        >
                          <Select placeholder="Month">
                            {
                              monthOptions.map((item: any) => (
                                <Option
                                  value={item.value}
                                  key={item.value}
                                >
                                  {item.text}
                                </Option>
                              ))
                            }
                          </Select>
                        </Form.Item>
                      </div>
                      <div className={styles['post-code-item']}>
                        <Form.Item
                          name="dobYear"
                        >
                          <DatePicker
                            style={{ width: '100%' }}
                            picker="year"
                            placeholder={'Year'}
                            suffixIcon={datePickerIcon}
                            disabledDate={(current) => current && (current.year() < 1900 || current.year() > previousYear)}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles['subscribe-title']}>
                Subscribe to our Newsletters:
                <b>{customerData?.subscribed4news && customerData.subscribed4news != null ? 'YES' : 'NO'}</b>
              </div>

              {
                customerData?.subscribed4news && customerData.subscribed4news != null
                  ?
                  <Link
                    href={'/my-account/emailPreferences'}
                    passHref
                    legacyBehavior
                  >
                    <a className={styles['subscribe-link']} target="_blank" rel="noopener noreferrer">Manage Newsletter Subscriptions</a>
                  </Link>
                  :
                  <Link
                    href={`/newsletters?email=${customerData?.login}`}
                    passHref
                    legacyBehavior
                  >
                    <a className={styles['subscribe-link']} target="_blank" rel="noopener noreferrer">Subscribe to our Newsletters</a>
                  </Link>
              }

              {/* 提交按钮 */}
              <Form.Item style={{ marginBottom: 0 }}>
                <div className={styles['btn-box']}>
                  <Button className={styles['save-btn']} htmlType="submit">Save</Button>
                  <Button className={styles['cancel-btn']} onClick={getCustomerInfo}>Cancel</Button>
                </div>
              </Form.Item>

              <div className={styles['tips']}>
                To see how we manage your personal information and other details, please check our&nbsp;
                <Link
                  href={'/article/privacy'}
                  passHref
                  legacyBehavior
                >
                  <a className={styles['tips-link']} rel="noopener noreferrer">Privacy Policy</a>
                </Link>
                &nbsp;and&nbsp;
                <Link
                  href={'/article/terms'}
                  passHref
                  legacyBehavior
                >
                  <a className={styles['tips-link']} rel="noopener noreferrer">Terms & Conditions</a>
                </Link>
                .
              </div>
            </Form>
          </div>
        </MyAccountLayout>
      </DefaultLayout>
    </>
  )
}